import Axios from "axios";
import constants from "../constants";

export default async function getContactColumnsData() {
    const getContactsColumnDataConfig = {
        method: "post",
        url: constants.graphql,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${window.localStorage.getItem("user_token")}`,
        },
        data: JSON.stringify({
            query: `{
                contactscolumndata {
                    id
                    column_name
                    column_type
                    tag
                }
            }`,
        }),
    };

    try {
        const { data } = await Axios(getContactsColumnDataConfig);
        if (data?.data?.contactscolumndata && Array.isArray(data.data.contactscolumndata)) {
            data.data.contactscolumndata.push({
                column_name: "Location",
                column_type: "location",
                tag: "location",
            });
            return data.data.contactscolumndata;
        }
        return [];
    } catch (error) {
        console.log("Error in getContactColumnsData", error);
        return [];
    }
}
